import { DEFAULT_FIELD_VALUES, ModelFactory } from "jimbo/model/base"; 
import {isNotUndefinedAndNotNull} from "jimbo/utils"

export const promotionPackageClassFactory = new ModelFactory();


const validateContentObjectOrUrl = (instance) => {
    const promotionUrl = instance.getFieldValue("promotionUrl");
    const publishedContentObject = instance.getFieldValue("publishedContentObject");

    const hasPromotionUrl = isNotUndefinedAndNotNull(promotionUrl)  && promotionUrl.length > 4
    const hasStorytrail = isNotUndefinedAndNotNull(publishedContentObject)

    console.log("has hasPromotionUrl ", hasPromotionUrl, " has storytrail ", hasStorytrail)

    if ( hasPromotionUrl || hasStorytrail){
         return null
    }
    return [{"message": "Website url or storytrail must have a value"}]
}


promotionPackageClassFactory.addClassDescriptionsData([
    {
        clazzName: "Promotion",
        verboseName: "None",
        additionalValidationFuction: validateContentObjectOrUrl,
        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "id",
                "auto_created": true,
                "type": "persistent.fields.CharField",
                "init_value": "null",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "name",
                "max_length": 512,
                "type": "persistent.fields.CharField",
            },  
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "isDefault",
                "type": "persistent.fields.BooleanField",
                "blank": true,
                "null": true,
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "publishStartDateTime",
                "type": "persistent.fields.DateTimeField",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "publishEndDateTime",
                "type": "persistent.fields.DateTimeField",
                "blank": true,
                "null": true,
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "publishedContentObject",
                "type": "persistent.fields.OneOf",
                "relation_clazz": "PublishedContentObjectProxy",
                "init_value": "null",
                "null": true,
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "imageContainer",
                "type": "persistent.fields.OneOf",
                "relation_clazz": "ImageContainerProxy",
                "init_value": "null",
                "null": false,
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "promotionUrl",
                "type": "persistent.fields.CharField",
                "blank": true,
                "null": true,
                "js_validate_regex": /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)*$/
            },
        ]
    },
    {
        clazzName: "ImageContainerProxy",
        verboseName: "ImageContainerProxy",
        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "id",
                "auto_created": false,
                "type": "persistent.fields.CharField",
                "init_value": "null",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "imageUrl",
                "max_length": 1024,
                "auto_created": true,
                "type": "persistent.fields.CharField",
            }
        ],

    },
    {
        clazzName: "PublishedContentObjectProxy",
        verboseName: "PublishedContent",
        fields: [
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "id",
                "auto_created": false,
                "type": "persistent.fields.CharField",
                "init_value": "null",
            },
            {
                ...DEFAULT_FIELD_VALUES,
                "name": "name",
                "max_length": 512,
                "type": "persistent.fields.CharField",
            }
        ],

    }
]);
